'use client'
import type { CSSProperties, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { usePathname } from 'next/navigation'
import ButtonLink from '@/design-system/buttons/ButtonLink'
import { useGoFusionToken } from '@/hooks/useGoFusionToken'
export default function Hero({
  illustration,
  title,
  description,
  partners,
  className,
  style,
}: {
  illustration: ReactNode
  title: ReactNode
  description: ReactNode
  partners?: ReactNode
  className?: string
  style?: CSSProperties
}) {
  const pathname = usePathname()
  const { token, redirectUrl } = useGoFusionToken()
  return (
    <>
      <div
        className={twMerge(
          'relative flex min-h-[588px] items-center justify-center px-4 pt-10 pb-20 md:min-h-full md:py-20',
          className
        )}
        style={style}>
        <div className="absolute left-4 top-4 z-10">
          <ButtonLink
            size="sm"
            color="text"
            className="leading-none close-skip-button"
            href={'#'}
            onClick={() => {
              if (token) {
                window.location.href = `${redirectUrl}/dashboard?token=${token}`;
              } else {
                window.history.pushState(null, '', `${pathname}?close`);
              }
            }}>
            <img 
              src="/images/back-arrow.svg"
              alt="Close"
              width={40}
              height={40}
            />
          </ButtonLink>
        </div>
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-between text-center">
          <div className="flex flex-col items-center gap-4 md:gap-10">
            <div className="max-w-[600px] text-center">
              <h1 className="mb-0 text-2xl leading-8 md:text-5xl md:leading-[3rem]">
                {title}
              </h1>
            </div>

            <div className="max-w-[600px] text-center text-sm md:text-lg">
              {description}
            </div>
          </div>

          <div className="hidden md:block">{illustration}</div>
        </div>
      </div>
      {partners && (
        <div className="w-full py-4 text-center text-sm text-gray-500">
          <div className="mx-8 border-t border-gray-300 pt-4">
            {partners}
          </div>
        </div>
      )}
    </>
  )
}